import { matchRoutes, useLocation } from 'react-router-dom';
import { routesPath } from '../router/routes';

export const useCurrentPath = () => {
  const routes = Object.values(routesPath).map(path => ({ path }));
  const location = useLocation();
  const match = matchRoutes(routes, location);

  return match?.[0]?.route.path;
};

export default useCurrentPath;
